// import * as React from 'react';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import Alert from '@mui/material/Alert';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
// Utils
import axiosInstance from '../../../utils/axios';
// ServiceForm
import ServiceForm from './ServiceForm';

const serviceForm = () => {
    const [service, setService] = useState({});
    const [alertError, setAlertError] = useState({});
    const [noService, setNoService] = useState(false);

    const { serviceId } = useParams();

    // call backend to retrieve services data by its id
    const getServices = async (id) => {
        await axiosInstance.post(`/services/get/${id}`)
            .then(response => {
                setService(response.data.service);
            })
            .catch(error => {
                console.error(error)
                
                setNoService(true);
                setAlertError(error.data.message)
            });
    }

    const handleAlertError = (message) => {
        setAlertError(message);
    }

    useEffect(() => {
        if (serviceId) {
            getServices(serviceId);
        }
    }, []);

    return (

        <Container component="div" maxWidth="md">
            <CssBaseline />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5">
                    Update Service
                </Typography>
            <>
                {
                    Object.keys(alertError).length !== 0 
                        ? <Alert 
                            severity="error"
                            sx={{m: 3}}
                        >
                            {alertError}
                        </Alert>
                        : null
                }
            </>

            {
                !noService
                    ? <ServiceForm service={service} handleError={handleAlertError} />
                    : null
            }

            </Box>
        </Container>
    );
}

export default serviceForm;